// extracted by mini-css-extract-plugin
module.exports =  {"link-button":"_0d624b9a27--link-button--ujZuh"};